import { render, staticRenderFns } from "./PostBoxIcon.vue?vue&type=template&id=0aca15ec&"
import script from "./PostBoxIcon.vue?vue&type=script&lang=js&"
export * from "./PostBoxIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports